import getFlightDetailsByOrderItems from 'lib/flights/getFlightDetailsByOrderItems'
import { getInsuranceDestinationCountriesFromOrder } from 'lib/order/orderInsuranceUtils'
import { createSelector } from 'reselect'

const getInsuranceDestinationCountriesFromExistingOrder = createSelector(
  (state: App.State) => state.checkout.cart.existingOrder,
  (state: App.State) => state.offer.offers,
  (state: App.State) => state.orders.flightDetails,
  (state: App.State) => state.experience.experiences,
  (order, offers, flightDetails, experienceOffers): Array<string> => {
    if (!order) return []

    const flightDetailsByOrderItems = getFlightDetailsByOrderItems(order, flightDetails)
    return getInsuranceDestinationCountriesFromOrder(order, offers, flightDetailsByOrderItems, experienceOffers)
  },
)

export default getInsuranceDestinationCountriesFromExistingOrder
